<template>
    <div class="row">
        <ContractInfo :loading="loading" :data="contract" />

        <div class="col-6">
            <div class="col-12 mb-3">
                <label class="form-label" for="end_date">
                    {{ $trans.get('__JSON__.End Date') }}
                </label>
                <input type="date" name="end_date" class="form-control" :class="{ 'is-invalid': this.hasError('end_date') }" id="end_date" v-model="formData.end_date">
                <span class="invalid-feedback" role="alert" v-if="this.hasError('end_date')">
                    <strong>{{ this.getError('end_date') }}</strong>
                </span>
            </div>
            <div class="col-12 mb-3">
                <label class="form-label" for="reason">
                    {{ $trans.get('__JSON__.End reason') }}
                </label>
                <v-select v-model="formData.reason" :options="reasons" :reduce="item => item.code" :class="{ 'is-invalid': this.hasError('reason') }" />
                <span class="invalid-feedback" role="alert" v-if="this.hasError('reason')">
                    <strong>{{ this.getError('reason') }}</strong>
                </span>
            </div>
            <div class="col-12">
                <label class="form-label" for="reason_specification">
                    {{ $trans.get('__JSON__.End specification') }}
                </label>
                <v-select v-model="formData.reason_specification" :options="reasonSpecifications" :reduce="item => item.code" :class="{ 'is-invalid': this.hasError('reason_specification') }" />
                <span class="invalid-feedback" role="alert" v-if="this.hasError('reason_specification')">
                    <strong>{{ this.getError('reason_specification') }}</strong>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import RequestHandler from "../../mixins/RequestHandler";
import ContractInfo from "../ContractInfo.vue";
import vSelect from "vue-select";

export default {
    name: 'TerminateContractForm',
    mixins: [ RequestHandler ],
    components: {vSelect, ContractInfo},
    data() {
        return {
            contractId: this.$parent.$data.contractId,
            loading: false,
            contract: {},
            formData: {
                end_date: null,
                reason: null,
                reason_specification: null,
            },
            reasons: this.$parent.$data.data.reasons,
            reasonSpecifications: this.$parent.$data.data.reasonSpecifications,
        }
    },
    methods: {
        fetch() {
            if (! this.contractId) return

            this.loading = true

            this.makeRequest('post', '/api/contract/info',
                {contractId: this.contractId},
                response => {
                    this.$parent.$data.data.contractType = response.data.contract.type
                    this.contract = response.data
                    this.formData.end_date = response.data.contract.end_date
                },
                error => console.log(error),
                () => this.loading = false
            )
        },
    },
    mounted() {
        this.fetch()
    },
}
</script>
